<template>
    <div class="modal_quinquenary_full" v-show="mainStore.isModalQuinquenaryVisible===true && mainStore.windowWidth>=960" style="background-image:url('/img/bg_buey.png');background-position: 50% 50%;background-repeat: no-repeat;background-size: cover;">
        <div class="container">
            <h1 class="return_full" @click="closeAll()">Volver al despiece</h1>
            <div class="container_in">
                <div class="top_bar">
                    <span @click="hideModal()">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <line x1="0.353553" y1="0.646447" x2="19.3536" y2="19.6464" stroke="#BEA58B"/>
                            <line x1="19.3536" y1="0.353553" x2="0.353553" y2="19.3536" stroke="#BEA58B"/>
                        </svg>
                    </span>
                </div>
            <div class="content_all" v-if="mainStore.isModalQuinquenaryVisible === true">
                <div class="image_container">
                    <img :src="mainStore.currentSpecific.img" alt="" style="width: 60%;align-self: center;margin-bottom: 10px;">
                </div>
                <div class="data_all">
                    <div class="data_current">
                        <h1 class="name">{{mainStore.currentSpecific.name}}</h1> 
                        <div class="description_full">
                            <div style="width: 50%;">
                            <p>
                {{mainStore.currentSpecific.descripcion}}
                
            </p>
            <button class="comprar">
                COMPRAR
            </button>
        </div>
        

                <div class="hotspots">
                <HotspotsViewerFull/>
            </div>
            </div>
            
            
           

            <h2 class="title">FICHA TÉCNICA</h2>
            <hr>
            <ul>
                <li><span class="section_feature">Maduración: </span> <span class="feature_description">{{mainStore.currentSpecific.ficha_tecnica.maduracion}}</span></li>
                <li><span class="section_feature">Estado: </span> <span class="feature_description">{{mainStore.currentSpecific.ficha_tecnica.estado}}</span></li>
                <li v-show="mainStore.currentSpecific.ficha_tecnica.formato!=''"><span class="section_feature">Formato: </span> <span class="feature_description">{{mainStore.currentSpecific.ficha_tecnica.formato}}</span></li>
                <li><span class="section_feature">Peso Aprox: </span> <span class="feature_description">{{mainStore.currentSpecific.ficha_tecnica.peso_aprox}}</span></li>
                <li><span class="section_feature">Conservación: </span> <span class="feature_description">{{mainStore.currentSpecific.ficha_tecnica.conservacion}}</span></li>
            </ul>
            <h2 class="title">RECOMENDACIONES</h2>
            <hr>
            <p class="recomendaciones">{{mainStore.currentSpecific.recomendaciones}}</p>
                    </div>

                    
                    
                </div>
            </div>
            </div>
        </div>
    </div>
   <div class="modal_quinquenary" v-show="mainStore.isModalQuinquenaryVisible===true && mainStore.windowWidth<960">
    <div class="upper_selector">
        <span class="volver" @click="closeAll()">Volver al despiece</span>
        <span @click="hideModal()"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<line x1="0.353553" y1="0.646447" x2="19.3536" y2="19.6464" stroke="#BEA58B"/>
<line x1="19.3536" y1="0.353553" x2="0.353553" y2="19.3536" stroke="#BEA58B"/>
</svg>
    </span>
    </div>
    
    <div class="section" v-if="mainStore.isModalQuinquenaryVisible === true">
            <img :src="mainStore.currentSpecific.img" alt="" style="width: 320px;align-self: center;margin-bottom: 10px;">
            <h1 class="name">{{mainStore.currentSpecific.name}}</h1> 
            <div class="hotspots" style="width: 100%;">
                <HotspotsViewer/>
            </div>
            <div class="description">
                {{mainStore.currentSpecific.descripcion}}
            </div>
            <!--COMPRAR -->
            <button class="comprar">
                COMPRAR
            </button>
            <!--COMPRAR -->

            <h2 class="title">FICHA TÉCNICA</h2>
            <hr>
            <ul>
                <li><span class="section_feature">Maduración: </span> <span class="feature_description">{{mainStore.currentSpecific.ficha_tecnica.maduracion}}</span></li>
                <li><span class="section_feature">Estado: </span> <span class="feature_description">{{mainStore.currentSpecific.ficha_tecnica.estado}}</span></li>
                <li v-show="mainStore.currentSpecific.ficha_tecnica.formato!=''"><span class="section_feature">Formato: </span> <span class="feature_description">{{mainStore.currentSpecific.ficha_tecnica.formato}}</span></li>
                <li><span class="section_feature">Peso Aprox: </span> <span class="feature_description">{{mainStore.currentSpecific.ficha_tecnica.peso_aprox}}</span></li>
                <li><span class="section_feature">Conservación: </span> <span class="feature_description">{{mainStore.currentSpecific.ficha_tecnica.conservacion}}</span></li>
            </ul>
            <h2 class="title">RECOMENDACIONES</h2>
            <hr>
            <p class="recomendaciones">{{mainStore.currentSpecific.recomendaciones}}</p>
        </div>
    </div>
</template>

<script>
import { useMainStore } from '@/stores/mainStore';
import allData from '../data/cortes_all.json';
import gsap from 'gsap';
import HotspotsViewer from './HotspotsViewer.vue';
import carne_img from '@/assets/carne.png';
import HotspotsViewerFull from './HotspotsViewerFull.vue';

export default{
    name: "ModalQuinquenay",
    setup() {
        const mainStore = useMainStore();
        return { mainStore };
    },
    data: function () {
        return {
            allData: allData,
            isToggled: false,
            carne_img: carne_img
        };
    },
    methods: {
        hideModal: function () {
            const tl = gsap.timeline();
            tl.add(this.mainStore.isModalQuinquenaryVisible = false);
            tl.to(document.querySelector(".modal_quinquenary"), { scale: 0, duration: 0.2 });
            tl.play();
        },
        
        closeAll: function(){
            this.mainStore.isModalQuinquenaryVisible = false;
            this.mainStore.isModalQuaternaryVisible = false;
        }
    },
    components: { HotspotsViewer, HotspotsViewerFull }
}
</script>

<style scoped>

.modal_quinquenary_full{
    position: absolute;
    width: 100%;
    height: 100vh;
    top:0;
    right:0;
    z-index: 20;
    transform: scale(0);
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #2b282c;
    gap:10px;
}
.return_full{
    color:#fff;
    text-decoration: underline;
    font-family: 'garamond';
    font-size: 18px;
    font-weight: 400;
}
.container{
  background: rgba(0,0,0,.8);
  top:0;
  left: 0;
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
}

.image_container{
 width: 40%;
 height:100%;
 text-align: center;
}

.content_all{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    height: 90%;
    width:100%;
}

.data_current{
    height: 100%;
    overflow-y:auto;
    padding-right: 35px;
}

/*.data_current::-webkit-scrollbar{
    display: none;
}*/

::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1; 
}
 
/* Handle */
::-webkit-scrollbar-thumb {
  background: #888; 
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555; 
}


.description_full{
    font-family:'garamond';
    color:#fff;
    font-weight: 400; 
    font-size:18px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}
.data_all{
    width: 60%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
}

.top_bar{
    width: 100%;
    height: 10%;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    padding: 20px;
}

.container_in{
    background: #2B282C;
  width: 80%;
  height:80%;
  display: flex;
  flex-direction: column;

}
.comprar{
    background-color: #967B60;
    font-family: 'Cervo';
    color: #fff;
    height: 48px;
    width: 96px;
    border: none;
    font-size: 18px;
    outline: none;
    margin-top:25px;
}
.modal_quinquenary{
    position: absolute;
    z-index: 30;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    transform: scale(0);
    background-color: #2b282c;
    overflow: auto;
    gap:15px;
}

.name{
    color:#fff;
    font-family: 'garamond';
    font-weight: 400;
}

.section{
    display:flex;
    flex-direction:column;
    max-width: 320px;
    gap:5px;
}

.section_feature{
    font-family: 'garamond';
    font-weight: 600;
    color:#fff;
    font-size: 18px;
}

.feature_description{
    font-family: 'garamond';
    font-weight: 400;
    color:#fff;
    font-size: 18px;
    margin-left: 2.5px;
}

.recomendaciones{
    font-family: 'garamond';
    font-weight: 400;
    color: #fff;
    font-size: 18px;
    margin-bottom: 25px;
}

ul>li{list-style: none;}

hr{
    border: 1px solid #BEA58B;
    margin: 5px 0 10px 0;
}

.name{
    color:#BEA58B;
    font-family: 'garamond';
    font-weight: 400;
    /*margin-top:10px;*/
    align-self: center;
    margin-bottom: 25px;
}

.title{
    font-family:'cervo';
    color:#fff;
    font-weight: 500;
    margin-top:25px;
}

.hotspots{
    /*margin-top:20px;
    margin-bottom:20px;*/
    /*padding: 0px 0px 30px 30px;*/
    margin-right:10px;
    width: 50%;
}

.description{
    font-family:'garamond';
    color:#fff;
    font-weight: 400; 
    font-size:18px;
}

.volver{
    color: #fff;
    text-decoration: underline;
    font-family: 'garamond';
    font-size: 18px;
}

.upper_selector{
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding-left: 25px;
    padding-right: 25px;
    margin-top: 20px;
}
</style>